import * as ActionTypes from './types.action';

export const getBanners = () => ({
  type: ActionTypes.GET_CMS_BANNERS_REQUESTED,
});

export const setBanner = banners => ({
  type: ActionTypes.GET_CMS_BANNERS_SUCCESS,
  banners,
});

export const getVacancies = () => ({
  type: ActionTypes.GET_CMS_VACANCIES_REQUESTED,
});

export const getCmsDepartments = () => ({
  type: ActionTypes.GET_CMS_DEPARTMENTS_REQUESTED,
});
